
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPosPrinterDialog extends Serenity.EntityDialog<PsPosPrinterRow, any> {
        protected getFormKey() { return PsPosPrinterForm.formKey; }
        protected getIdProperty() { return PsPosPrinterRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosPrinterRow.localTextPrefix; }
        protected getNameProperty() { return PsPosPrinterRow.nameProperty; }
        protected getService() { return PsPosPrinterService.baseUrl; }
        protected getDeletePermission() { return PsPosPrinterRow.deletePermission; }
        protected getInsertPermission() { return PsPosPrinterRow.insertPermission; }
        protected getUpdatePermission() { return PsPosPrinterRow.updatePermission; }

        protected form = new PsPosPrinterForm(this.idPrefix);

    }
}